import { useEffect } from "react";
import { Contract, Status } from "../../models/ContractTypes";
import { GedSharepointListItem } from "../../models/SharePointTypes";
import { StoreAddContractStatus, StoreGetCodeSp } from "../../hooks/ContractStore";
import { StoreRequestProjectWorkspace } from "../../hooks/SharePointStore";

export interface ContractWorkspace {  
  // Données des stores
  addStatus: (projectId: number, status: Status) => Promise<void>;
  responseAddedItem: any;
  getCodeSp: (serviceId: number) => Promise<void>;
  responseCodeSp: any;
  requestProjectWorkspace: (projectId: number, item: GedSharepointListItem) => Promise<void>;
  responseRequestProjectWorkspace: any;
  errorRequestProjectWorkspace: any;
}

export function useWorkspaceService (choosenContract: Contract[], creationButtonIsClicked:any): ContractWorkspace {
  const choosenContractOne: Contract = choosenContract[0];

  const { addStatus, responseAddedItem } = StoreAddContractStatus(); // update/create status to ged database
  const { getCodeSp, responseCodeSp } = StoreGetCodeSp();
  const { requestProjectWorkspace, responseRequestProjectWorkspace, errorRequestProjectWorkspace } = StoreRequestProjectWorkspace(); // demande de création d'un espace documentaire

  //recherche du code sharepoint du service dont dépend le projet
  useEffect(() => {
      getCodeSp(choosenContractOne.serviceId);
  }, [choosenContractOne]);

  useEffect(() => {
      requestWorkspace();
  }, [creationButtonIsClicked]);


  function requestWorkspace (){
    const itemToAdd: GedSharepointListItem = {
      title: choosenContractOne.projectName,
      idIovision: choosenContractOne.projectId,
      typeProject: '',
      contactChefProjet: choosenContractOne.projectSupervisorEmail,
      contactCommercial: choosenContractOne.projectSalesRepresentativeEmail,
      client: choosenContractOne.customerName,
      serviceId: choosenContractOne.serviceId,
      dateProjet: choosenContractOne.startDate.toString().split('T')[0]
    };

    if (creationButtonIsClicked && responseCodeSp?.code_sp != null) {
      requestProjectWorkspace(choosenContractOne.projectId, itemToAdd); // Envoi vers SharePoint
      addStatus(choosenContractOne.projectId, Status.CREER); // Envoi vers la base de données locale GED
    }
  };

  return {   
    // Données des stores
    addStatus,
    responseAddedItem,
    getCodeSp,
    responseCodeSp,
    requestProjectWorkspace,
    responseRequestProjectWorkspace,
    errorRequestProjectWorkspace,   
  };
};

